<template>
    <div class="house-map-card" :class="{'rented': !house.empty}" :data-id="house.cid" :data-district="house.district" @click.stop="clickEvent" @mouseenter="changeAddressIcon(), findMarker()" @mouseleave="changeAddressIcon">
        <div class="house-map-card-wrap">
            <div v-if="house.coverImage" class="house-image">
                <img :src="imageUrl(house.coverImage)" alt="">
            </div>
            <div v-else class="house-image">
                <img src="@/assets/img/component/houseCard/default.jpg" alt="">
            </div>
            <div class="content-wrap">
                <div class="house-map-card-title">
                    {{house.houseName}}
                </div>
                <div class="house-map-card-address">
                    {{house.address}}
                </div>
                <img id="address-icon" :src="addressIcon"  @click.stop="setHouseCenter({lat: house.lat, lng: house.lng})" alt="">
                <div class="house-map-card-price">
                    ${{price}}
                </div>
                <div class="house-state">
                    <span v-if="house.publish" class="put">上架</span>
                    <span v-else class="off">下架</span>
                    <span v-if="house.complete" class="completed">完善</span>
                    <span v-else class="uncompleted">未完善</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import constant from '@/constant'
export default {
    name: 'HouseCard',
    data () {
        return {
            addressIcon: require('@/assets/img/icon/address_green_border.svg')
        }
    },
    props:{
        house: ''
    },
    methods: {
        changeAddressIcon: function () {
            if( event.type == 'mouseenter' ){
                this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            }else if( event.type == 'mouseleave' ){
                this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            }
        },
        // hover找尋地圖標記,改變顏色
        findMarker: function () {
            // console.log(event.target.dataset.district)
            let houseDistrict = event.target.dataset.district,
                houseId = event.target.dataset.id,
                districts = document.querySelectorAll('.district'),
                clusters = document.querySelectorAll('.custom-clustericon')
                
            if( districts.length > 0 ){
                for (let i = 0; i < districts.length; i++) {
                    const district = districts[i];
                    if( houseDistrict == district.dataset.district ){
                        district.style.background = '#f5a623'
                    }else{
                        district.style.background = '#ff9275'
                    }
                }
            }
            if( clusters.length > 0 ){
                for (let i = 0; i < clusters.length; i++) {
                    const cluster = clusters[i];
                    
                    // console.log(cluster.title.match(houseId))
                    if(cluster.title.match(houseId)){
                        cluster.style.background = '#f5a623'
                    }else{
                        cluster.style.background = '#ff9275'
                    }
                    
                }
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clickEvent: function (){
            window.open('/landlord/housestatus/edithouse?cid='+this.house.cid)
        },
        setHouseCenter: function (latlng) {
            // console.log(latlng)
            this.$store.commit('houseManagement/set_filter_query_county', this.house.county)
            this.$store.commit('houseManagement/set_filter_query_district', this.house.district)
            this.$store.commit('houseManagement/set_house_marker_center', latlng)

        },
        imageUrl: function (url){
            return constant.imageUrl+url
        }
    },
    computed: {
        price: function () {
            return this.toCurrency(this.house.rentPrice)
        }
    },
}
</script>
<style lang="scss" scoped>
    .house-map-card{
        position: relative;
        width: 352px;
        // height: 96px;
        background: #fff;
        margin: 0 24px;
        padding: 20px 0px;
        border-bottom: 1px solid #f3f3f3;
        .house-map-card-wrap{
            display: flex;
            align-items: center;
            // .house-state{
            //     position: absolute;
            //     width: 26px;
            //     height: 26px;
            //     right: 20px;
            //     top: 20px;
            //     display: flex;
            //     align-items: center;
            //     justify-content: center;
            //     border-radius: 4px;
            //     background-color: #cacfcd;
            //     color: #fff;
            //     font-size: 12px;
            // }
            .house-image{
                width: 128px;
                height: 96px;
                border-radius: 4px;
                margin-right: 16px;
                display: flex;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
                >img{
                    width: 100%;
                }
            }
            .content-wrap{
                .house-map-card-title{
                    font-size: 20px;
                    margin-bottom: 10px;
                }
                .house-map-card-address{
                    width: 176px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    font-weight: 300;
                    margin-bottom: 11px;
                }
                #address-icon{
                    cursor: pointer;
                    position: absolute;
                    right: -4px;
                    bottom: 52px;
                }
                .house-map-card-price{
                    font-size: 16px;
                    font-weight: 500;
                }
                .house-state{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    right: 0px;
                    bottom: 19px;
                    span{
                        width: 52px;
                        height: 26px;
                        background-color: #cacfcd;
                        color: #fff;
                        font-size: 12px;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    span.put{
                        background-color: rgba(113, 170, 229, 0.1);
                        color: #71aae5;
                        margin-right: 8px;
                    }
                    span.off{
                        background-color: #f3f3f3;
                        color: #676362;
                        margin-right: 8px;
                    }
                    span.completed{
                        background-color: #71aae5;
                    }
                    span.uncompleted{
                        background-color: #ff9275;
                    }
                }
            }
        }
        
    }
    @media screen and (max-width: 1280px) {
        .house-map-card{
            width: 270px;
            .house-map-card-wrap{
                .house-image{
                    display: none;
                }
                .content-wrap{
                    padding: 11px 0px;
                    .house-map-card-address{
                        width: 220px;
                    }
                }
            }
        }
        
    }
    // .house-map-card.rented{
    //     // border: solid 1px #525956;
    //     .house-map-card-wrap{
    //         .house-state{
    //             background-color: #525956;
    //         }
    //     }
    // }
    // .house-map-card:hover{
    //     background: #ff9275;
    //     // border: solid 1px #ff9275;
    //     .house-map-card-wrap{
    //         .house-state{
    //              background-color: rgba(255, 255, 255, 0.2);
    //         }
    //         .content-wrap{
    //             .house-map-card-title{
    //                 color: #fff;
    //             }
    //             .house-map-card-address{
    //                 color: #fff;
    //             }
    //             .house-map-card-price{
    //                 color: #fff;
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/landlord/landlordMapSearch/MapHouseCard.vue